import React from "react";
import "./RangilpurBranch.css";
import { useNavigate } from "react-router-dom";

const FACILITIES = [
  { icon: "🏫", label: "Modern Classrooms" },
  { icon: "🔬", label: "Science & Computer Labs" },
  { icon: "📚", label: "Library" },
  { icon: "⚽", label: "Sports Ground" },
  { icon: "🚌", label: "Transport Service" },
];

const ADDRESS = "Rangilpur, Multan, Pakistan";
const PHONE_DISPLAY = "+92 321 6309158";
const PHONE_LINK = "+923216309158";
const EMAIL = "academicgroupofschools@gmail.com";

const MAP_EMBED_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13622.764444016956!2d71.4536969!3d30.1530436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b320ac5b04f6f%3A0xabcdef123456789!2s30%C2%B009'11.0%22N%2071%C2%B027'22.6%22E!5e0!3m2!1sen!2s!4v1694936502045!5m2!1sen!2s";

const DIRECTIONS_URL =
  "https://www.google.com/maps/place/30%C2%B009'11.0%22N+71%C2%B027'22.6%22E/@30.1530436,71.4536969,17z";

function RangilpurBranch() {
  const navigate = useNavigate();

  return (
    <main className="bb">
      {/* Hero */}
      <header className="bb-hero">
        <div className="bb-hero__inner">
          <span className="bb-hero__badge">Academic Group of Schools</span>
          <h1 className="bb-hero__title">Rangilpur Branch</h1>
          <p className="bb-hero__text">
            Welcome to the Rangilpur Branch. We are committed to providing
            quality education, strong moral values, and modern facilities for
            our students.
          </p>
          <button
            type="button"
            className="bb-btn bb-btn--light"
            onClick={() => navigate("/ApplyForm")}
          >
            Apply Now
          </button>
        </div>
      </header>

      <div className="bb-content">
        {/* About */}
        <section className="bb-section" aria-labelledby="bb-about">
          <h2 id="bb-about" className="bb-section__title">
            About Our Branch
          </h2>
          <p className="bb-section__text">
            The Rangilpur Branch features well-structured classrooms, science
            and computer laboratories, a library, and spacious grounds for
            sports and extracurricular activities. Our focus is to deliver high
            academic standards and character development.
          </p>
        </section>

        {/* Facilities */}
        <section className="bb-section" aria-labelledby="bb-facilities">
          <h2 id="bb-facilities" className="bb-section__title">
            Facilities
          </h2>
          <ul className="bb-facilities">
            {FACILITIES.map((item) => (
              <li key={item.label} className="bb-facilities__item">
                <span className="bb-facilities__icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Contact */}
        <section className="bb-section" aria-labelledby="bb-contact">
          <h2 id="bb-contact" className="bb-section__title">
            Contact Information
          </h2>
          <div className="bb-contact">
            <div className="bb-contact__card">
              <span className="bb-contact__icon" aria-hidden="true">
                📍
              </span>
              <div>
                <h3 className="bb-contact__label">Address</h3>
                <p className="bb-contact__value">{ADDRESS}</p>
              </div>
            </div>

            <div className="bb-contact__card">
              <span className="bb-contact__icon" aria-hidden="true">
                📞
              </span>
              <div>
                <h3 className="bb-contact__label">Phone</h3>
                <p className="bb-contact__value">
                  <a href={`tel:${PHONE_LINK}`}>{PHONE_DISPLAY}</a>
                </p>
              </div>
            </div>

            <div className="bb-contact__card">
              <span className="bb-contact__icon" aria-hidden="true">
                ✉️
              </span>
              <div>
                <h3 className="bb-contact__label">Email</h3>
              <p className="bb-contact__value">
  <a className="bb-contact__email" href={`mailto:${EMAIL}`}>
    {EMAIL}
  </a>
</p>
              </div>
            </div>
          </div>
        </section>

        {/* Map */}
        <section className="bb-section" aria-labelledby="bb-map">
          <h2 id="bb-map" className="bb-section__title">
            Find Us on Map
          </h2>
          <div className="bb-map">
            <iframe
              title="Rangilpur Branch Location"
              src={MAP_EMBED_SRC}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            href={DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bb-btn bb-btn--primary"
          >
            📍 Get Directions
          </a>
        </section>
      </div>
    </main>
  );
}

export default RangilpurBranch;
